import React, { useContext, useEffect, useState } from 'react'
import ModalMain from '../../../../components/Modal/ModalMain'
import ModalHeader from '../../../../components/Modal/ModalHeader';
import { Dropdown } from '@fluentui/react';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import { t } from 'i18next';
import { extendStudyExpiration } from '../../../../service/StudyViewerService';
import studyviewerContext from '../../../../context/studyviewer/StudyviewerContext';
import { eventBus } from '../../../Annotations/helper/initialData';
import studyReportContext from '../../../../context/studyreport/StudyReportContext';

const StudyExpirationPopup = (props) => {
    const { studyParentId, setShowStudyExpirationPopup, showStudyAlreadyExpiredPopup, setShowStudyAlreadyExpiredPopup, checkStudyExpired, setCheckStudyExpired } =
    useContext(studyviewerContext);

    const { releaseStudy } = useContext(studyReportContext);

    let isBvpPlatform = (process.env.REACT_APP_BVP_PLATFORM == "true" || process.env.REACT_APP_BVP_PLATFORM == true) ? true : false;

    useEffect(() => {
      if(document.fullscreenElement) {
        document.exitFullscreen().catch((err) => {
          console.error('Failed to exit fullscreen:', err);
        });
      }
    }, []);

    useEffect(() => {
      eventBus.on("configureStudyExpirationModal", (evtData) => {
        console.log("Event is listening...........");
        console.log(evtData);
        setShowStudyAlreadyExpiredPopup(evtData.show);
      });
    }, []);

    let PrimaryButtonList = showStudyAlreadyExpiredPopup ? [
        {
          title: t("button.ok"),
          onclick: () => {
            window.close();
          },
        },
      ] : [
        {
          title: t("study-expiration.button.extend"),
          onclick: () => {
            console.log("extend clicked")
            handleStudyExpirationExtent();
          },
        },
        isBvpPlatform ? {
            title: t("study-expiration.button.release"),
            onclick: () => {
              console.log("return clicked")
              handleStudyRelease();
            },
          } : {
            title: t("study-expiration.button.return"),
            onclick: () => {
              console.log("return clicked")
              handleStudyReturn();
            },
          },
      ];

    const modalDetails = {
        header: (
          <ModalHeader
              heading={t("study-expiration.title")}
              hideCancelIcon={true}
              updatedModal={true}
            />
        ),
        body: <div className="return-study-container">
            <div className="return-study-content">
            <div className="ReturnStudyContentContainer">
                <div className="content-1">
                {!showStudyAlreadyExpiredPopup && <p id = "timerDisplayOnPopup">study will expire in </p>}
                {showStudyAlreadyExpiredPopup && <p>Study is expired. You can no longer save or submit. </p>}
                </div>
            </div>
            </div>
        </div>,
        footer: (
          <ModalFooter
             PrimaryButtonList={PrimaryButtonList}
          />
        ),
        width: "400px", 
      };

  const handleStudyExpirationExtent = async () => {
    const response = await extendStudyExpiration(studyParentId);
    console.log(response)
    if (response.status == 200 && response.data.data == true) {
      setShowStudyExpirationPopup(false);
      setCheckStudyExpired(!checkStudyExpired);
    }
  }

  const handleStudyReturn = () => {
    props.setShowReturnStudyModal(true);
  }

  const handleStudyRelease = () => {
    releaseStudy(studyParentId);
    setShowStudyExpirationPopup(false);
  }

  return (
    <>
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />
    </>
  )
}

export default StudyExpirationPopup
